export default Object.freeze({
  address: {},
  contact: {},
  companyName: '',
  usage: {},
});
